<template>
  <div class="address-input">
    <ValidationProvider
      v-slot="{ errors }"
      :name="label || 'Adresse'"
      :rules="validationRules"
    >
      <TextInput
        ref="input"
        v-model="internalValue"
        class="w-full"
        :name="name"
      />
      <i class="fal fa-map-marker-alt"></i>
      <span v-show="errors.length" class="text-danger text-sm">{{
        errors[0]
      }}</span>
    </ValidationProvider>
  </div>
</template>

<script>
import TextInput from "./TextInput";

export default {
  components: {
    TextInput
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        street: null,
        city: null,
        zip: null,
        country: null,
        lat: null,
        lng: null,
        formatted_address: null
      })
    },
    validationRules: {
      type: [Object, String],
      default() {
        return null;
      }
    },
    label: { type: String, default: null },
    placeholder: { type: String, default: null },
    output: { type: String, default: "full" },
    name: { type: String, required: true },
    modelReplaces: { type: String, required: false }
  },
  data: () => ({
    autocomplete: null,
    internalValue: null
  }),
  watch: {
    value: {
      immediate: true,
      handler(v) {
        if (v && this.autocomplete && v.formatted_address) {
          this.internalValue = v.formatted_address;
        }
      }
    }
  },
  mounted() {
    if (!this.internalValue) {
      this.internalValue = this.modelReplaces;
    }
    if (!window.google) {
      let script = document.createElement("script");
      script.onload = this.initAutocomplete;
      script.async = true;
      script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.VUE_APP_MAPS_API_KEY}&libraries=places`;
      document.head.appendChild(script);
    } else {
      this.initAutocomplete();
    }
  },
  methods: {
    initAutocomplete() {
      this.autocomplete = new window.google.maps.places.Autocomplete(
        this.$refs.input.$el.querySelector("input"),
        {
          // bounds: defaultBounds,
          // types: ['establishment']
        }
      );

      this.autocomplete.addListener("place_changed", () => {
        this.placeChanged(this.autocomplete.getPlace());
      });
    },
    placeChanged(place) {
      if (!place.geometry) {
        return;
      }

      this.$emit("input", {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
        formatted_address: place.formatted_address
      });
      this.$emit("formatted-address", place.formatted_address);
    }
  }
};
</script>
